const ruleindex = (resolve) => require(['@/page/rule/index'], resolve)
const home = (resolve) => require(['@/page/home/home'], resolve)
const list = (resolve) => require(['@/page/rule/list'], resolve)
const details = (resolve) => require(['@/page/rule/details'], resolve)
const routes = [
  { path: "/", name: "index", redirect: '/home' },
  { path: "/home", name: "home", component: home },

  {
    path: "/list", name: "ruleindex", component: ruleindex,
    children: [
      { path: "/list", name: "list", component: list },
      { path: "/details", name: "details", component: details }
    ]
  },
]
export default routes
